import { CodigoProductoEnum } from 'src/app/global/enums/codigo-producto.enum';
import { NombresProductoEnum } from 'src/app/global/enums/nombres-producto.enum';
import { NombresTipoVentaEnum } from 'src/app/global/enums/nombres-tipo-venta.enum';
import { ProductResponse } from 'src/app/global/interfaces/product-response';
import { SeleccionProductoRequest } from 'src/app/global/interfaces/seleccion-producto.request';
import { SeleccionProductoResponse } from 'src/app/global/interfaces/seleccion-producto.response';
import { Product } from './product';


export class ProductBuilder {
  private valorIva;
  private etiquetaTipoVenta;
  private valorTotalUF;
  private valorNeto;
  private newAmountUF;


  fromSeleccionProductoResponse(productResponseList: SeleccionProductoResponse): Product[] {
    if (!productResponseList) {
      return [];
    }

    const products: Product[] = [];
    for (const responseProduct of productResponseList.producto) {
      const nombre = NombresProductoEnum[responseProduct.id] !== undefined ? NombresProductoEnum[responseProduct.id] : responseProduct.nombre;
      this.verificarTipoMoneda(responseProduct);
      const product: Product = {
        isOpen: false,
        articleId: '0',
        codigoProducto: responseProduct.id,
        title: nombre,
        valorProduct: responseProduct.valor,
        valorEI: '',
        valorEF: '',
        valorRealUf: responseProduct.valorUF,
        amount: responseProduct.tipoMoneda === 'UF' ? this.transform(Math.round(this.valorIva).toString()) : this.transform(String(responseProduct.valor * responseProduct.cantidad).toString()),
        amountUF: responseProduct.tipoMoneda === 'UF' ? String(Intl.NumberFormat('es-CL').format(this.valorTotalUF)).toString() : this.newAmountUF,
        urlExterna: 'https://portaltransbank.cl/afiliacion/registrate.html#/login/1',
        tipoVenta: responseProduct.tipoVenta,
        rangoCantidades: responseProduct.cantidad !== undefined ? [1, 2, 3, 4, 5] : null,
        cantidad: responseProduct.cantidad !== undefined ? '0' : null,
        tipoProducto: responseProduct.tipoProducto,
        business: null,
        plan: responseProduct.tipoMoneda == 'UF' ? responseProduct.valor : null,
        tipoConexiones: responseProduct.cantidad !== undefined && responseProduct.tipoConexion !== undefined ? ['RED_INTERNET', 'RED_CELULAR'] : null,
        cantidadI: null,
        cantidadF: null,
        tipoConexion: responseProduct.tipoConexion,
        etiquetaVenta: responseProduct.oferta === 'VENTA' ? true : false,
        tipoFlujo: 'nuevo',
        etiquetaTipoVenta: this.etiquetaTipoVenta,
        etiquetaProducto: '',
        cantidadDias: responseProduct.diasArriendo,
        moneda: responseProduct.tipoMoneda,
        leyendaIva: 'valor aprox. con IVA'
      };
      if (responseProduct.cantidad == undefined) {
        delete product.cantidad;
      }

      this.addCantidades(product, responseProduct);

      products.push(product);
    }
    return products;
  }

  private verificarTipoMoneda(responseProduct: ProductResponse) {
    if (responseProduct.tipoMoneda === 'UF') {
      this.valorTotalUF = responseProduct.valor * (responseProduct.cantidad !== undefined ? responseProduct.cantidad : 1);
      this.valorNeto = (this.valorTotalUF * responseProduct.valorUF);
      this.valorIva = this.valorNeto * 1.19;
      this.etiquetaTipoVenta = NombresTipoVentaEnum[responseProduct.tipoVenta] !== undefined ? NombresTipoVentaEnum[responseProduct.tipoVenta] : null;
    } else {
      const valorSinIva: number = responseProduct.valor / 1.19;
      const newValorUF: number = Math.fround((valorSinIva / responseProduct.valorUF));
      // this.newAmountUF = String(newValorUF * responseProduct.cantidad).substr(0, 4).replace('.', ',');
      this.newAmountUF = (newValorUF * responseProduct.cantidad).toFixed(2).replace('.', ',');
    }
  }

  transform(value: string): string {
    const valueReturn = value
      .replace(/[^0-9]/g, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return valueReturn;
  }

  toSeleccionProductoRequest(products: Product[]): SeleccionProductoRequest[] {
    const productRequestList: SeleccionProductoRequest[] = [];
    for (const product of products) {
      const productRequest: SeleccionProductoRequest = {
        producto: {
          id: product.codigoProducto,
          asString: product.title,
          tipoProducto: product.tipoProducto,
          valor: Number(product.amount)
        },
        cantidad: null,
        cantidadFijo: null,
        cantidadMovil: null,
        diasArriendo: null,
        idEvento: null,
        idPST: null
      };
      this.addCantidadesToProductoRequest(productRequest, product);
      productRequestList.push(productRequest);
    }
    return productRequestList;
  }

  private addCantidades(product: Product, responseProduct: ProductResponse): void {

    let cantidad = '';
    if (responseProduct.cantidad) {
      cantidad = responseProduct.cantidad.toString();
    }

    switch (responseProduct.id) {
      case CodigoProductoEnum.ARRIENDO_PACK_INTERNET:
      case CodigoProductoEnum.ARRIENDO_PACK_CELULAR:
        product.cantidadF = cantidad;
        product.cantidadI = cantidad;
        break;
      case CodigoProductoEnum.VENTA_MPOS:
      case CodigoProductoEnum.VENTA_MPOS_GARANTIA:
      case CodigoProductoEnum.PACK_VENTA_MPOS_LP:
      case CodigoProductoEnum.PACK_VENTA_MPOS_LP_GARANTIA:
      case CodigoProductoEnum.ARRIENDO_MPOS:
      case CodigoProductoEnum.ARRIENDO_POS_MOVIL:
      case CodigoProductoEnum.ARRIENDO_POS_FIJO_INTERNET:
      case CodigoProductoEnum.ARRIENDO_POS_FIJO_CELULAR:
      case CodigoProductoEnum.ARRIENDO_POS_MOVIL_FERIA:
      case CodigoProductoEnum.ARRIENDO_POS_MOVIL_20DIAS:
      case CodigoProductoEnum.ARRIENDO_POS_MOVIL_90DIAS:
      case CodigoProductoEnum.ARRIENDO_SMARTPOS:
      case CodigoProductoEnum.ARRIENDO_LITE_POS:
      case CodigoProductoEnum.PACK_POS_MOVIL_LP:
      default:
        product.cantidad = cantidad;
    }


    // TODO add map diasArriendo to any product attribute

  }

  private addCantidadesToProductoRequest(productRequest: SeleccionProductoRequest, product: Product): void {
    switch (product.codigoProducto) {
      case CodigoProductoEnum.ARRIENDO_PACK_INTERNET:
        productRequest.cantidadFijo = {
          asInt: product.cantidadF,
          present: true
        };
        break;
      case CodigoProductoEnum.ARRIENDO_PACK_CELULAR:
        productRequest.cantidadMovil = {
          asInt: product.cantidadI,
          present: true
        };
        break;
      case CodigoProductoEnum.VENTA_MPOS:
      case CodigoProductoEnum.VENTA_MPOS_GARANTIA:
      case CodigoProductoEnum.PACK_VENTA_MPOS_LP:
      case CodigoProductoEnum.PACK_VENTA_MPOS_LP_GARANTIA:
      case CodigoProductoEnum.ARRIENDO_MPOS:
      case CodigoProductoEnum.ARRIENDO_POS_MOVIL:
      case CodigoProductoEnum.ARRIENDO_POS_FIJO_INTERNET:
      case CodigoProductoEnum.ARRIENDO_POS_FIJO_CELULAR:
      case CodigoProductoEnum.ARRIENDO_SMARTPOS:
      case CodigoProductoEnum.ARRIENDO_LITE_POS:
      case CodigoProductoEnum.PACK_POS_MOVIL_LP:
        productRequest.cantidad = Number(product.cantidad);
        break;
      case CodigoProductoEnum.ARRIENDO_POS_MOVIL_20DIAS:
      case CodigoProductoEnum.ARRIENDO_POS_MOVIL_90DIAS:
        productRequest.cantidad = Number(product.cantidad);
        productRequest.diasArriendo = Number(product.cantidadDias);
        break;
      case CodigoProductoEnum.ARRIENDO_POS_MOVIL_FERIA:
        productRequest.cantidad = Number(product.cantidad);
        productRequest.idEvento = Number(product.idEvento);
        break;

      // TODO add case for map id event values to product request

      // TODO add case for map diasArriendo values to product request
    }

  }
}
